import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col, FormGroup, ControlLabel, FormControl, InputGroup, Alert, Panel } from 'react-bootstrap';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertFromRaw } from 'draft-js';
import ReactMarkdown from 'react-markdown';
import { draftToMarkdown, markdownToDraft } from 'markdown-draft-js';

class TemplateProducer extends Component {
  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    instructions: PropTypes.string,
    reactComponentName: PropTypes.string,
  }
  constructor(props) {
    super(props);

    const { instructions } = this.props;
    const rawContent = markdownToDraft(instructions);
    const content = convertFromRaw(rawContent);

    this.state = {
      editorState: instructions? EditorState.createWithContent(content) : EditorState.createEmpty()
    }
  }
  render() {
    const { title, description, instructions, reactComponentName, onChange } = this.props;

    return (
      <Row>
        <Col xs={12}>
          <InputGroup>
            <ControlLabel>Title</ControlLabel>
            <FormControl onChange={e => onChange('title', e.target.value)} placeholder='Enter a title.' value={title} />
          </InputGroup><br />
          <InputGroup>
            <ControlLabel>Description</ControlLabel>
            <FormControl onChange={e => onChange('description', e.target.value)} placeholder='Enter a brief description.' value={description} />
          </InputGroup><br />
          <InputGroup>
            <ControlLabel>Component Name (Developer Only)</ControlLabel>
            <FormControl onChange={e => onChange('reactComponentName', e.target.value)} placeholder='Enter a component name.' value={reactComponentName} />
          </InputGroup><br />
          <Row>
            <Col md={12}>
              <InputGroup>
                <ControlLabel>Instructions</ControlLabel>
                <Editor
                  editorState={this.state.editorState}
                  onEditorStateChange={editorState => this.setState({ editorState })}
                  onContentStateChange={contentState => onChange('instructions', draftToMarkdown(contentState))}
                />
              </InputGroup>
            </Col>
            {/* <Col md={6}>
              <ReactMarkdown source={instructions || ''} />
            </Col> */}
          </Row>
        </Col>
      </Row>
    );
  }
}

export default TemplateProducer;



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/template-producer.js